import React, {useEffect, useState} from 'react';
import Header from './header/Header';
import DetailTabs from './detailTabs/DetailTabs';
import DropArea from './dropArea/DropArea';
import DiagramBuilder from '../../autom/DiagramBuilder/DiagramBuilder';
import './MiddleArea.css';

const MiddleArea = ({
                        automDetail,
                        operationId,
                        setAutomDetail,
                        handleDragStart,
                        resetFlow,
                        saveFlow,
                        runFlow,
                        debugFlow,
                        tabFilter,
                        setTabFilter,
                        detailTabs,
                        setDetailTabs,
                        editFlow,
                        isFocused,
                        setOpenSchedule,
                        setTriggerModal,
                        triggerType,
                        handleStart,
                        handleStop,
                        isRunning,
                        trigger,
                        setOpenDrive,
                        publishFlow,
                        debuggingStart,
                        setDebuggingExpand,
                        openRunningModal,
                        openDebugRunning,
                        setOpenDebugRunning,
                        debuggingExpand,
                        handleDiagramBuilder,
                        handleRoi,
                        findAndUpdateItem,
                        isDiagramBuilder,
                        diagramData,
                        setIsDiagramBuilder,
                        setDiagramData,
                        setOpenRoi,
                        setShowRightArea,
                        setShowTriggerRightArea,
                        handleDebugIconShow,
                        handleExport,
                        handleImport,
                        handleSlowMotion,
                        setFlowStatus,
                        handleErrorOpenClick,
                        handleErrorCloseClick,
                        variables,
                        setOpenVariable,
                        action,
                        reCheck,
                        setReCheck,
                        openResetTriggerConfiguration,
                        testAppStarted,
                        handleTestAppCancel,
                        automaticallyVariableCreation,
                        automaticallyWhatsappVariableCreation,
                        getVariables,
                        updateVariableByItemId
                    }) => {
    let relativeX = 0, relativeY = 0, drag = false;
    let topFlow = 0;

    const handleDrag = e => {
        e.stopPropagation();
        drag = true;
        let rect = e.target.getBoundingClientRect();
        relativeX = e.clientX - rect.left;
        relativeY = e.clientY - rect.top;
        setTimeout(() => e.target.style.visibility = 'collapse', 10);
    }

    const handleDrop = e => {
        e.stopPropagation();
        if (drag) {
            let rect = e.target.getBoundingClientRect();
            let x = e.clientX - rect.left - relativeX;
            let y = e.clientY - rect.top - relativeY;
            const flow = document.getElementById('new-flow-drop-area-grid');
            const container = document.getElementById('flow-container');
            flow.style.left = x + container.scrollLeft + 'px';
            flow.style.top = y + container.scrollTop + 'px';
            flow.style.visibility = 'visible';
            drag = false;
        }
    }

    const handleDragEnd = () => {
        const flow = document.getElementById('new-flow-drop-area-grid');
        flow.style.visibility = 'visible';
        drag = false;
    }

    const [isWheel, setIsWheel] = useState(false);

    useEffect(() => {
        const el = document.getElementById("flow-container");
        el.addEventListener("wheel", (event) => {
            const flow = document.getElementById("new-flow-drop-area-grid");
            const delta = Math.sign(event.deltaY);
            const offsetChangeValue = 50;
            const elem = document.getElementById("flow-stop");

            if (elem !== undefined && elem !== null) {
                const topPosition = flow.offsetTop;
                const flowStop = elem.offsetTop;

                if (delta === -1) {
                    if (topPosition < el.offsetHeight - 250) {
                        flow.style.top =
                            (topPosition + offsetChangeValue).toString() + "px";
                        topFlow = topPosition + offsetChangeValue;
                        setIsWheel(true);
                    }
                } else {
                    if (topPosition > -flowStop + 150) {
                        flow.style.top =
                            (topPosition - offsetChangeValue).toString() + "px";
                        topFlow = topPosition - offsetChangeValue;
                        setIsWheel(true);
                    }
                }
            }
        });


        el.addEventListener("keydown", (event) => {
            const flow = document.getElementById("new-flow-drop-area-grid");
            let offsetChangeValue = 50;
            const elem = document.getElementById("flow-stop");
            const actions = document.getElementsByClassName("drag-container-area")[0];
            if (actions?.offsetHeight > 100 && actions?.offsetHeight < 250) offsetChangeValue = 100;
            else if (actions?.offsetHeight > 250 && actions?.offsetHeight < 500) offsetChangeValue = 200;
            else if (actions?.offsetHeight > 500 && actions?.offsetHeight < 750) offsetChangeValue = 325;
            else if (actions?.offsetHeight > 750 && actions?.offsetHeight < 1000) offsetChangeValue = 450;
            else if (actions?.offsetHeight > 1000 && actions?.offsetHeight < 1500) offsetChangeValue = 550;
            else if (actions?.offsetHeight > 1500 && actions?.offsetHeight < 2000) offsetChangeValue = 650;
            else if (actions?.offsetHeight > 2000 && actions?.offsetHeight < 2500) offsetChangeValue = 750;
            else if (actions?.offsetHeight > 2500 && actions?.offsetHeight < 3050) offsetChangeValue = 850;
            else if (actions?.offsetHeight > 3050 && actions?.offsetHeight < 4050) offsetChangeValue = 950;
            else if (actions?.offsetHeight > 4050 && actions?.offsetHeight < 5050) offsetChangeValue = 1100;
            else if (actions?.offsetHeight > 5050 && actions?.offsetHeight < 7050) offsetChangeValue = 1300;
            else if (actions?.offsetHeight > 7050 && actions?.offsetHeight < 10500) offsetChangeValue = 1500;
            else if (actions?.offsetHeight > 10500 && actions?.offsetHeight < 15000) offsetChangeValue = 1700;
            else if (actions?.offsetHeight > 15000) offsetChangeValue = 2000;
            if (elem !== undefined && elem !== null) {
                const topPosition = flow.offsetTop;
                const flowStop = elem.offsetTop;
                if (event.ctrlKey && event.keyCode === 35) {
                    if (topPosition > -flowStop + 150) {
                        flow.style.top =
                            (topPosition - offsetChangeValue).toString() + "px";
                        topFlow = topPosition - offsetChangeValue;
                        setIsWheel(true);
                    }
                } else if (event.ctrlKey && event.keyCode === 36) {
                    if (topPosition < el.offsetHeight - 250) {
                        flow.style.top =
                            (topPosition + offsetChangeValue).toString() + "px";
                        topFlow = topPosition + offsetChangeValue;
                        setIsWheel(true);
                    }
                }
            }
        })
    }, []);

    return (
        <div className="new-flow-middle-area">
            <Header
                automDetail={automDetail}
                operationId={operationId}
                resetFlow={resetFlow}
                saveFlow={saveFlow}
                runFlow={runFlow}
                openDebugRunning={openDebugRunning}
                setOpenDebugRunning={setOpenDebugRunning}
                debugFlow={debugFlow}
                editFlow={editFlow}
                setTriggerModal={setTriggerModal}
                setOpenSchedule={setOpenSchedule}
                triggerType={triggerType}
                handleStop={handleStop}
                handleStart={handleStart}
                isRunning={isRunning}
                trigger={trigger}
                setOpenDrive={setOpenDrive}
                publishFlow={publishFlow}
                debuggingStart={debuggingStart}
                setFlowStatus={setFlowStatus}
                testAppStarted={testAppStarted}
                handleTestAppCancel={handleTestAppCancel}
            />
            {!isDiagramBuilder ?
                <div>
                    <DiagramBuilder
                        isDiagramBuilder={isDiagramBuilder}
                        diagramData={diagramData}
                        setDiagramData={setDiagramData}
                        setIsDiagramBuilder={setIsDiagramBuilder}
                        setOpenRoi={setOpenRoi}
                    />
                </div> :
                <>
                    <DetailTabs
                        automName={automDetail.name}
                        tabFilter={tabFilter}
                        setTabFilter={setTabFilter}
                        setDetailTabs={setDetailTabs}
                        detailTabs={detailTabs}/>
                    <DropArea
                        handleDragStart={handleDragStart}
                        automDetail={automDetail}
                        setAutomDetail={setAutomDetail}
                        setDetailTabs={setDetailTabs}
                        detailTabs={detailTabs}
                        isFocused={isFocused}
                        debuggingStart={debuggingStart}
                        openRunningModal={openRunningModal}
                        setDebuggingExpand={setDebuggingExpand}
                        debuggingExpand={debuggingExpand}
                        handleDiagramBuilder={handleDiagramBuilder}
                        handleRoi={handleRoi} handleDrag={handleDrag} handleDragEnd={handleDragEnd}
                        findAndUpdateItem={findAndUpdateItem} handleDrop={handleDrop}
                        handleDebugIconShow={handleDebugIconShow}
                        setShowRightArea={setShowRightArea}
                        setShowTriggerRightArea={setShowTriggerRightArea}
                        handleImport={handleImport}
                        handleExport={handleExport}
                        handleSlowMotion={handleSlowMotion}
                        handleErrorOpenClick={handleErrorOpenClick}
                        handleErrorCloseClick={handleErrorCloseClick}
                        variables={variables}
                        setOpenVariable={setOpenVariable}
                        action={action}
                        setReCheck={setReCheck} reCheck={reCheck}
                        openResetTriggerConfiguration={openResetTriggerConfiguration}
                        automaticallyVariableCreation={automaticallyVariableCreation}
                        setTriggerModal={setTriggerModal} setOpenSchedule={setOpenSchedule}
                        automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                        getVariables={getVariables}
                        updateVariableByItemId={updateVariableByItemId}
                    />
                </>
            }
        </div>
    );
}
export default MiddleArea;
